import { h } from "preact";

export default function MonogramAccordion({
  id,
  number,
  title,
  open,
  onToggle,
  children,
}) {
  const toggleId = `${id}-toggle`;
  const panelId = `${id}-panel`;

  return (
    <div class={`monogram-accordion${open ? " monogram-accordion--open" : ""}`}>
      <h3 class="monogram-accordion__heading">
        <button
          type="button"
          id={toggleId}
          class="monogram-accordion__toggle body-bold"
          aria-expanded={open ? "true" : "false"}
          aria-controls={panelId}
          onClick={onToggle}
        >
          <span>
            {number}. {title}
          </span>
          <svg
            class="monogram-accordion__icon"
            width="14"
            height="8"
            viewBox="0 0 14 8"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M0.666664 0.666656L6.66666 6.66666L12.6667 0.666656"
              stroke="currentColor"
              stroke-width="1.33333"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </h3>
      {/* Collapsed by a 0fr grid row so the height animates; inert keeps the
          hidden controls out of the tab order meanwhile. */}
      <div
        id={panelId}
        class="monogram-accordion__panel"
        role="region"
        aria-labelledby={toggleId}
        inert={!open}
      >
        <div class="monogram-accordion__panel-inner">
          <div class="monogram-accordion__content">{children}</div>
        </div>
      </div>
    </div>
  );
}
